if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.modalSwiper = null;
        this.modalSliderReadyBound = false;
      }

      connectedCallback() {
        if (this.modalSliderReadyBound) return;
        this.modalSliderReadyBound = true;
        super.connectedCallback();

        if (typeof window.Swiper === 'undefined') {
          document.addEventListener('DOMContentLoaded', () => this.initializeSlider(), { once: true });
        } else {
          this.initializeSlider();
        }
      }

      hide() {
        this.modalSwiper?.zoom?.out();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia(opener);
      }

      initializeSlider(forceRebuild = false) {
        const slider = this.querySelector('.product-modal-swiper');
        if (!slider || typeof window.Swiper === 'undefined') return;

        if (forceRebuild && this.modalSwiper) {
          this.modalSwiper.destroy(true, true);
          this.modalSwiper = null;
        }

        if (slider.swiper && !forceRebuild) {
          this.modalSwiper = slider.swiper;
          return;
        }

        this.modalSwiper = new window.Swiper(slider, {
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 450,
          observer: true,
          observeParents: true,
          zoom: {
            enabled: true,
            maxRatio: 3,
            minRatio: 1,
            toggle: false,
          },
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
          },
          keyboard: {
            enabled: true,
            onlyInViewport: false,
          },
          on: {
            tap(swiper, event) {
              if (!event.target.closest('.swiper-zoom-container')) return;
              swiper.zoom.toggle(event);
            },
            slideChangeTransitionStart() {
              this.zoom?.out();
              slider.querySelectorAll('.variant-gallery-modal-video').forEach((video) => video.pause());
            },
          },
        });

        this.dataset.swiperBound = 'true';
      }

      getOpeningSlideIndex(opener) {
        const slides = Array.from(this.querySelectorAll('.product-modal-swiper .swiper-slide'));
        if (!slides.length) return 0;

        const mediaId = opener?.dataset.mediaId;
        if (mediaId) {
          const mediaIndex = slides.findIndex((slide) => slide.dataset.slideMediaId === mediaId);
          if (mediaIndex >= 0) return mediaIndex;
        }

        const gallery = document.querySelector(`#MediaGallery-${this.dataset.section}`);
        const gallerySwiper = gallery?.querySelector('.product-swiper-main')?.swiper;
        return Math.min(gallerySwiper?.realIndex || gallerySwiper?.activeIndex || 0, slides.length - 1);
      }

      showActiveMedia(opener = this.openedBy) {
        this.initializeSlider();

        const slideIndex = this.getOpeningSlideIndex(opener);
        if (this.modalSwiper) {
          this.modalSwiper.update();
          this.modalSwiper.slideTo(slideIndex, 0, false);
        }

        const activeSlide = this.querySelectorAll('.product-modal-swiper .swiper-slide')[slideIndex];
        const deferredMedia = activeSlide?.querySelector('deferred-media, product-model');
        if (deferredMedia?.querySelector('template')?.content.querySelector('.js-youtube')) {
          deferredMedia.loadContent();
        }
      }
    }
  );
}
